const iconArrowLeftTemplate = () =>
  `<svg width="80" height="80" viewBox="0 0 80 80" xmlns="http://www.w3.org/2000/svg" class="icon__svg icon__svg--arrow-left">
    <path fill="currentColor" d="M60 80V0L20 40z" fill-rule="evenodd"></path>
  </svg>`;

const iconArrowRightTemplate = () =>
  `<svg width="80" height="80" viewBox="0 0 80 80" xmlns="http://www.w3.org/2000/svg" class="icon__svg icon__svg--arrow-right">
    <path fill="currentColor" d="M20 0v80l40-40z" fill-rule="evenodd"></path>
  </svg>`;

export const prevArrowTemplate = () =>
  `<i class="icon icon--arrow-navigation icon--arrow-right icon--small icon--c-dark">${iconArrowLeftTemplate()}</i>`;

export const nextArrowTemplate = () =>
  `<i class="icon icon--arrow-navigation icon--arrow-right icon--small icon--c-dark">${iconArrowRightTemplate()}</i>`;

const calendarTemplate = id => `
<div class="c-archive-toolbar__date j-archive-toolbar__date" id="${id}toggle">
<span id="${id}span"></span>
<i class="icon  icon--calendar icon--xsmall icon--c-dark">
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80" class="icon__svg icon__svg--calendar"><path d="M75.3 6.9H59.5V4.1c0-1.6-1.3-3-3-3-1.6 0-3 1.3-3 3v2.8H29.4V4.1c0-1.6-1.3-3-3-3-1.6 0-3 1.3-3 3v2.8H4.7C2.2 6.9.1 9 .1 11.5v63.6c0 2.5 2.1 4.6 4.6 4.6h70.6c2.5 0 4.6-2.1 4.6-4.6V11.5c0-2.5-2.1-4.6-4.6-4.6zm-51.9 7v2.3c0 1.7 1.4 3 3 3s3-1.3 3-3v-2.3h24.1v2.3c0 1.7 1.4 3 3 3s3-1.3 3-3v-2.3h13.4v10.4H7.1V13.9h16.3zM7.1 72.7V31.3h65.8v41.4H7.1z"></path></svg>
</i>
<form>
   <div class="flatpickr-wrapper">
      <input class="c-calendar j-calendar flatpickr-input" type="text" placeholder="Seleziona una data" id="${id}" data-calendar-data='{"year":"2019", "month":"11", "day":"22","mode":"single"}' readonly="readonly">
   </div>
</form>
</div>`;

const archiveToolbarPrevTemplateActive = (text, href) =>
  `
<a class="c-cta c-cta--reverse c-cta--no-outline c-cta--capitalized c-archive-toolbar__prev" href="${href}">
<span class="c-cta__text">${text}</span>
<i class="icon icon--arrow-navigation icon--arrow-link icon--small icon--c-primary">
   <svg width="80" height="80" viewBox="0 0 80 80" xmlns="http://www.w3.org/2000/svg" class="icon__svg icon__svg--arrow-link">
      <path d="M67.488 35.963L56.259 25.458c-1.328-1.242-1.335-3.264-.017-4.515 1.319-1.251 3.464-1.258 4.792-.016l17.965 16.807c1.393 1.304 1.323 3.446-.153 4.666L58.518 59.207c-1.407 1.163-3.548 1.031-4.782-.294s-1.094-3.342.312-4.505l14.587-12.06H3.388C1.517 42.348 0 40.918 0 39.155c0-1.763 1.517-3.192 3.388-3.192h64.1z" fill="currentColor" fill-rule="evenodd"></path>
   </svg>
</i>
</a>`;

const archiveToolbarNextTemplateActive = (text, href) =>
  `
<a class="c-cta c-cta--no-outline c-cta--capitalized c-archive-toolbar__next" href="${href}">
<span class="c-cta__text">${text}</span>
<i class="icon icon--arrow-navigation icon--arrow-link icon--small icon--c-primary">
   <svg width="80" height="80" viewBox="0 0 80 80" xmlns="http://www.w3.org/2000/svg" class="icon__svg icon__svg--arrow-link">
      <path d="M67.488 35.963L56.259 25.458c-1.328-1.242-1.335-3.264-.017-4.515 1.319-1.251 3.464-1.258 4.792-.016l17.965 16.807c1.393 1.304 1.323 3.446-.153 4.666L58.518 59.207c-1.407 1.163-3.548 1.031-4.782-.294s-1.094-3.342.312-4.505l14.587-12.06H3.388C1.517 42.348 0 40.918 0 39.155c0-1.763 1.517-3.192 3.388-3.192h64.1z" fill="currentColor" fill-rule="evenodd"></path>
   </svg>
</i>
</a>`;

const archiveToolbarNextTemplateDisabled = () => `
<a class="c-cta c-cta--no-outline c-cta--capitalized c-archive-toolbar__next is-transparent">
<span class="c-cta__text">NO, MONTH</span>
<i class="icon icon--arrow-navigation icon--arrow-link icon--small icon--c-primary">
   <svg width="80" height="80" viewBox="0 0 80 80" xmlns="http://www.w3.org/2000/svg" class="icon__svg icon__svg--arrow-link">
      <path d="M67.488 35.963L56.259 25.458c-1.328-1.242-1.335-3.264-.017-4.515 1.319-1.251 3.464-1.258 4.792-.016l17.965 16.807c1.393 1.304 1.323 3.446-.153 4.666L58.518 59.207c-1.407 1.163-3.548 1.031-4.782-.294s-1.094-3.342.312-4.505l14.587-12.06H3.388C1.517 42.348 0 40.918 0 39.155c0-1.763 1.517-3.192 3.388-3.192h64.1z" fill="currentColor" fill-rule="evenodd"></path>
   </svg>
</i>
</a>`;

const archiveToolbarPrevTemplateDisabled = () =>
  `
<a class="c-cta c-cta--reverse c-cta--no-outline c-cta--capitalized c-archive-toolbar__prev is-transparent">
<span class="c-cta__text">NO, MONTH</span>
<i class="icon icon--arrow-navigation icon--arrow-link icon--small icon--c-primary">
   <svg width="80" height="80" viewBox="0 0 80 80" xmlns="http://www.w3.org/2000/svg" class="icon__svg icon__svg--arrow-link">
      <path d="M67.488 35.963L56.259 25.458c-1.328-1.242-1.335-3.264-.017-4.515 1.319-1.251 3.464-1.258 4.792-.016l17.965 16.807c1.393 1.304 1.323 3.446-.153 4.666L58.518 59.207c-1.407 1.163-3.548 1.031-4.782-.294s-1.094-3.342.312-4.505l14.587-12.06H3.388C1.517 42.348 0 40.918 0 39.155c0-1.763 1.517-3.192 3.388-3.192h64.1z" fill="currentColor" fill-rule="evenodd"></path>
   </svg>
</i>
</a>`;

export const render = (archiveToolbar, { prevText, prevHref, calendarId, nextText, nextHref }) => {
  prevHref !== null
    ? (archiveToolbar.innerHTML += archiveToolbarPrevTemplateActive(prevText, prevHref))
    : (archiveToolbar.innerHTML += archiveToolbarPrevTemplateDisabled());

  archiveToolbar.innerHTML += calendarTemplate(calendarId);

  nextHref !== null
    ? (archiveToolbar.innerHTML += archiveToolbarNextTemplateActive(nextText, nextHref))
    : (archiveToolbar.innerHTML += archiveToolbarNextTemplateDisabled());
};
